export const localesFilesMap: Record<any, string> = {
  "/": "landingPage",
  "/converter/xd-to-sketch": "XDToSketch",
  "/converter/xd-to-figma": "XDToFigma",
  "/converter/sketch-to-xd": "SketchToXD",
  "/converter/sketch-to-figma": "SketchToFigma",
  "/converter/figma-to-sketch": "FigmaToSketch",
  "/converter/figma-to-xd": "FigmaToXD",
  "/converter/sketch-to-psd": "SketchToPPSD",
  "/converter/xd-to-psd": "XDToPSD",
  "/converter/figma-to-psd": "FigmaToPSD",
  "/converter/ai-to-figma": "AIToFigma",
  "/converter/ai-to-sketch": "AIToSketch",
  "/converter/pdf-to-figma": "PDFToFigma",
  "/converter/pdf-to-xd": "PDFToXD",
  "/converter/pdf-to-psd": "PDFToPSD",
  "/converter/pdf-to-sketch": "PDFToSketch",
  "/converter/figma-to-ai": "FigmaToAI",
  "/converter/psd-to-figma": "PSDToFigma",
  "/converter/psd-to-sketch": "PSDToSketch",
  "/converter/google-slides-to-figma": "GoogleSlidesToFigma",
  "/converter/figma-to-google-slides": "FigmaToGoogleSlides",
  "/converter/sketch-to-ai": "SketchToAI",
  "/converter/xd-to-ai": "XDToAI",
  "/converter/eps-to-figma": "EPSToFigma",
  "/converter/canva-to-figma": "CanvaToFigma",
  "/converter/figma-to-canva": "FigmaToCanva",
  "/converter/indesign-to-figma": "IndesignToFigma",
  "/converter/indesign-to-xd": "IndesignToXd",
  "/converter/indesign-to-sketch": "IndesignToSketch",
  "/converter/figma-to-powerpoint": "FigmaToPowerPoint",
  "/converter/powerpoint-to-figma": "PowerPointToFigma",
  "/converter/powerpoint-to-xd": "PowerPointToXd",
  "/converter/powerpoint-to-sketch": "PowerPointToSketch",
  "/converter/powerpoint-to-canva": "PowerPointToCanva",
  "/converter/pdf-to-indesign": "PDFToIndesign",
  "/converter/website-to-figma": "WebsiteToFigma",
  "/converter/figma-to-axure": "FigmaToAxure",
  "/converter/express-to-figma": "ExpressToFigma",
  "/converter/figma-to-after-effects": "FigmaToAfterEffects",
  "/converter/figma-to-pdf": "FigmaToPDF",
  "/converter/xd-to-pdf": "XDToPDF",
  "/converter/canva-to-powerpoint": "CanvaToPowerpoint",
  "/converter/canva-to-googleslides": "CanvaToGoogleslides",
  "/converter/canva-to-psd": "CanvaToPSD",
  "/converter/canva-to-xd": "CanvaToXd",
  "/converter/xd-to-jpg": "XDToJPG",
  "/converter/xd-to-powerpoint": "XDToPowerpoint",
  "/converter/freehand-to-figjam": "FreehandToFigjam",
};
